import styled from 'styled-components'

export const LoadMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`
